import { createFileRoute } from '@tanstack/react-router'

import { InvoiceImportDetailPage } from '@/pages/invoices/import/[id]/InvoiceImportDetailPage'

export const Route = createFileRoute('/_authenticated/_dashboard/invoices/import/$id/')({
  component: InvoiceImportDetailPage,
})
